import { render, staticRenderFns } from "./AddResellerServiceComponent.vue?vue&type=template&id=66fb6a36"
import script from "./AddResellerServiceComponent.vue?vue&type=script&lang=js"
export * from "./AddResellerServiceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports